<c-sidebar #sidebar="cSidebar" class="d-print-none sidebar sidebar-fixed" id="sidebar" [unfoldable]="sidebarUnfoldable" visible>
  <c-sidebar-brand [brandFull]="{
      src: 'assets/img/brand/logo-igreja.png',
      width: 200,
      height: 46,
      alt: 'Logo'
    }" [brandNarrow]="{
      src: 'assets/img/brand/logo-igreja-min.png',
      width: 46,
      alt: 'Logo'
    }" routerLink="./">
  </c-sidebar-brand>
  <perfect-scrollbar [config]="perfectScrollbarConfig">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="path">
    </c-sidebar-nav>
  </perfect-scrollbar>
  <c-sidebar-toggler *ngIf="!sidebar.narrow" toggle="unfoldable" cSidebarToggle="sidebar"></c-sidebar-toggler>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-base-layout-header class="mb-2 d-print-none header header-sticky" position="sticky" sidebarId="sidebar"
    [headerNavItems]="headerNavItems" [userName]="userName" [tmLogout]="tmLogout"></app-base-layout-header>
  <!--app-body-->
  <div class="app body flex-grow-1 mb-2">
    <ng-container *ngIf="isFluidContainer; else defaultContainer">
      <c-container [fluid]="true">
        <router-outlet></router-outlet>
      </c-container>
    </ng-container>
    <ng-template #defaultContainer>
      <c-container breakpoint="lg">
        <router-outlet></router-outlet>
      </c-container>
    </ng-template>
  </div>
  <!--app footer-->
  <app-base-layout-footer class="pt-0 pb-0" [unitName]="unitName" [orgLink]="organizacaoLink"></app-base-layout-footer>
</div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
  <p style="color: white">Aguarde ...</p>
</ngx-spinner>
